<template>
  <div class="container">
    <div class="box-title">
      <h4>
        <i class="fal fa-route"></i>
        ເສັ້ນທາງຂົນສົ່ງ (TMS)
        <span class="countTotal">({{ count }})</span>
        <span class="btn-add">
          <vs-button circle icon flat @click="GoToBuilder()">
            <i class="fal fa-plus-circle"></i>
          </vs-button>
        </span>
      </h4>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-5">
          <div class="control">
            <label class="label">ຄົ້ນຫາ (ຊື່ເສັ້ນທາງ)</label>
            <input class="input" placeholder="ຄົ້ນຫາຊື່ເສັ້ນທາງ..." v-model="searchItem" @keyup.enter="OnFilterChange">
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">ສະຖານະ</label>
            <div class="select">
              <select class="input" v-model="selectedActive" @change="OnFilterChange">
                <option value="">ທັງໝົດ</option>
                <option value="1">ເປີດໃຊ້ງານ</option>
                <option value="0">ສະບັບຮ່າງ</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ລະຫັດ</vs-th>
            <vs-th>ຊື່ເສັ້ນທາງ</vs-th>
            <vs-th>ເສັ້ນທາງທີ່ແລ່ນ</vs-th>
            <vs-th>ຈຸດແວະ</vs-th>
            <vs-th>ໄລຍະທາງ (km)</vs-th>
            <vs-th v-if="CanViewCost">ລາຄາ/ຖ້ຽວ</vs-th>
            <vs-th>ຖ້ຽວ/ອາທິດ</vs-th>
            <vs-th>ຈຳນວນຖ້ຽວແລ້ວ</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th title="ສ້າງຖ້ຽວອັດຕະໂນມັດທຸກມື້ (18:00)">ຖ້ຽວອໍໂຕ</vs-th>
            <vs-th></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr :key="index" :data="route" v-for="(route, index) in routes">
            <vs-td :style="{textAlign: 'center'}">{{ index + 1 }}</vs-td>
            <vs-td :style="{color: 'crimson'}">{{ route.code || '...' }}</vs-td>
            <vs-td :style="{color: '#195BFF'}">{{ route.name }}</vs-td>
            <vs-td>{{ route.running_route || '...' }}</vs-td>
            <vs-td :style="{textAlign: 'center'}">{{ route.stops_count }}</vs-td>
            <vs-td>{{ route.distance_km || '...' }}</vs-td>
            <vs-td v-if="CanViewCost">{{ FleetFormatNumber(route.standard_trip_price) }}</vs-td>
            <vs-td :style="{textAlign: 'center'}">{{ route.trips_per_week || '...' }}</vs-td>
            <vs-td :style="{textAlign: 'center'}">{{ route.trips_count }}</vs-td>
            <vs-td>
              <span :style="{color: route.is_active ? '#2dcc70' : '#e8a10f'}">
                {{ route.is_active ? 'ເປີດໃຊ້ງານ' : 'ສະບັບຮ່າງ' }}
              </span>
            </vs-td>
            <vs-td :style="{textAlign: 'center'}">
              <vs-button circle icon flat @click="ToggleAutoDaily(route)"
                         :title="route.auto_daily_rounds
                           ? 'ປິດການສ້າງຖ້ຽວອັດຕະໂນມັດທຸກມື້'
                           : 'ເປີດການສ້າງຖ້ຽວອັດຕະໂນມັດທຸກມື້ (18:00)'">
                <i :class="route.auto_daily_rounds ? 'fal fa-calendar-check' : 'fal fa-calendar-times'"
                   :style="{color: route.auto_daily_rounds ? '#2dcc70' : '#b0b0b0'}"></i>
              </vs-button>
            </vs-td>
            <vs-td style="text-align: right; width: 150px">
              <div class="group-icon">
                <vs-button circle icon flat @click="OpenRouteQr(route)" title="ພິມ QR ສາຍລົດ">
                  <i class="fal fa-qrcode"></i>
                </vs-button>
                <vs-button circle icon flat @click="ToggleStatus(route)"
                           :title="route.is_active ? 'ປິດເປັນສະບັບຮ່າງ' : 'ເປີດໃຊ້ງານ'">
                  <i :class="route.is_active ? 'fal fa-toggle-on' : 'fal fa-toggle-off'"></i>
                </vs-button>
                <vs-button circle icon flat @click="GoToBuilder(route.id)">
                  <i class="fad fa-pencil-alt"></i>
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <Pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="OnPaginate()"></Pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>

    <!-- Fixed route QR label (FR-{id}): staff scan it to pick the route; the
         system picks the trip. QR for phone cameras, Code128 for 1D guns, the
         text for typing. -->
    <vs-dialog v-model="qrDialog.open" width="420px">
      <template #header>
        <h4>ປ້າຍ QR ສາຍລົດ</h4>
      </template>
      <div v-if="qrDialog.loading" class="qr-loading">ກຳລັງໂຫຼດ...</div>
      <div v-else-if="qrDialog.data" ref="qrLabel" class="route-qr-label">
        <div class="route-qr-name">{{ qrDialog.data.name }}</div>
        <div v-if="qrDialog.data.code" class="route-qr-code">{{ qrDialog.data.code }}</div>
        <div class="route-qr-svg" v-html="qrDialog.data.svg"></div>
        <VueBarcode :value="qrDialog.data.qr" :height="60" :width="2" :font-size="16" :margin="4"
                    :display-value="true"></VueBarcode>
        <div class="route-qr-hint">ສະແກນເພື່ອເລືອກສາຍລົດ — ລະບົບຈະເລືອກຖ້ຽວໃຫ້</div>
      </div>
      <template #footer>
        <div class="qr-actions">
          <vs-button :disabled="!qrDialog.data" @click="PrintRouteQr()">
            <i class="fal fa-print"></i>&nbsp;ພິມ
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import Loading from '@views/Loading';
import Pagination from '@/Plugins/Paginations/Pagination';
import MixinFleetRoutes from '@/Mixins/Fleet/Routes';

export default {
  components: {
    Loading,
    Pagination,
    VueBarcode,
  },
  mixins: [MixinFleetRoutes],
  data: () => ({
    qrDialog: {open: false, loading: false, data: null},
  }),
  watch: {
    searchItem(value) {
      if (value === '') {
        this.OnFilterChange();
      }
    },
  },
  methods: {
    // Filters live in the URL query so builder -> back keeps the view.
    SyncQuery() {
      const query = {};
      if (this.searchItem) query.q = this.searchItem;
      if (this.selectedActive !== '') query.active = String(this.selectedActive);
      const page = (this.pagination && this.pagination.current_page) || 1;
      if (page > 1) query.page = String(page);
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({query}).catch(() => {});
      }
    },
    OnFilterChange() {
      this.pagination.current_page = 1;
      this.SyncQuery();
      this.FetchRoutes();
    },
    OnPaginate() {
      this.SyncQuery();
      this.FetchRoutes();
    },
    GoToBuilder(routeId) {
      if (routeId) {
        this.$router.push({name: 'fleet.routes.builder', query: {id: routeId}});
      } else {
        this.$router.push({name: 'fleet.routes.builder'});
      }
    },
    ToggleAutoDaily(route) {
      this.SetRouteAutoDaily(route.id, !route.auto_daily_rounds).then(() => {
        this.FetchRoutes();
      }).catch(() => {
      });
    },
    OpenRouteQr(route) {
      this.qrDialog = {open: true, loading: true, data: null};
      this.FetchRouteQr(route.id).then((data) => {
        this.qrDialog.data = data;
        this.qrDialog.loading = false;
      }).catch(() => {
        this.qrDialog.loading = false;
      });
    },
    // Print just the label in its own window — the page CSS stays out of it.
    PrintRouteQr() {
      const label = this.$refs.qrLabel;
      if (!label) return;
      const win = window.open('', '_blank', 'width=480,height=640');
      if (!win) return;
      win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${this.qrDialog.data.qr}</title>
        <style>
          body{margin:0;font-family:'Noto Sans Lao',sans-serif;display:flex;justify-content:center}
          .route-qr-label{width:90mm;padding:6mm;text-align:center;border:1px dashed #999}
          .route-qr-name{font-size:18px;font-weight:bold}
          .route-qr-code{font-size:14px;color:#c00;margin-top:2px}
          .route-qr-svg svg{width:60mm;height:60mm}
          .route-qr-hint{font-size:11px;margin-top:4px}
        </style></head><body>${label.outerHTML}</body></html>`);
      win.document.close();
      win.focus();
      setTimeout(() => {
        win.print();
      }, 250);
    },
    ToggleStatus(route) {
      this.SetRouteStatus(route.id, !route.is_active).then(() => {
        this.FetchRoutes();
      }).catch(() => {
      });
    },
  },
  created() {
    const query = this.$route.query || {};
    if (query.q) this.searchItem = query.q;
    if (query.active !== undefined && query.active !== '') this.selectedActive = query.active;
    if (query.page) this.pagination.current_page = Number(query.page) || 1;

    this.FetchRoutes();
  },
};
</script>

<style scoped>
.route-qr-label {
  text-align: center;
}

.route-qr-name {
  font-size: 18px;
  font-weight: bold;
}

.route-qr-code {
  color: crimson;
  margin-top: 2px;
}

.route-qr-svg >>> svg {
  width: 220px;
  height: 220px;
}

.route-qr-hint {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.qr-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
